/* eslint-disable */
import React from "react";
import { useState } from "react";
import HeAppWrapper from "../../components/HeAppWrapper";
import "./App.scss";

// // Uncomment the following to load 3rd party scripts
import { useEffect } from "react";

let jQuery = window.jQuery;
function App() {
    const [state, setState] = useState({
        // // Uncomment the following to load 3rd party scripts
        // allScriptsLoaded: false
    });

    useEffect(()=>{
        //function to fix height of iframe!
        var calcHeight = function () {
            jQuery('#preview-frame').height(jQuery(window).height()-3);
        };
        jQuery(document).ready(function () {
            calcHeight();
        });
        jQuery(window).resize(function () {
            calcHeight();
        }).load(function () {
            calcHeight();
        });
    },[])


    // // Uncomment the following to load 3rd party scripts
    // useEffect(() => {
    //     if (state.allScriptsLoaded) {
    //         // sttuf to do after the 3rd party dependencies have loaded
    //     }
    // }, [state.allScriptsLoaded]);
    // const [loaded1, error1] = useScript("/wp-content/plugins/he-apps/legacyResources/jsLibs/openlayers/OpenLayers.js");
    // if (!state.allScriptsLoaded && loaded1) {
    //     setState({ allScriptsLoaded: true });
    // }


    return (
        <HeAppWrapper className="app-san-luis-valley">
            <iframe style={{height: 500, width:'100%'}} id="preview-frame" src="/wp-content/plugins/he-apps/legacyResources/appData/san-luis-valley-fire-story/index.html" name="preview-frame" frameborder="0" noresize="noresize"></iframe>
        </HeAppWrapper>
    );
}

export default App;
